import { render, staticRenderFns } from "./website-home.vue?vue&type=template&id=42306224&scoped=true"
import script from "./website-home.vue?vue&type=script&lang=js"
export * from "./website-home.vue?vue&type=script&lang=js"
import style0 from "./website-home.vue?vue&type=style&index=0&id=42306224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42306224",
  null
  
)

export default component.exports